import React from 'react'
import { map } from 'lodash'
import styled from 'styled-components'

import theme from '~/truck/theme'

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${theme.spacing.cozy}px;
  }
`

const Column = props => {
  const { data } = props

  return (
    <Container>
      {map(data, item => (
        <li>{item.name}</li>
      ))}
    </Container>
  )
}

export default Column
